import { render, staticRenderFns } from "./comentariosContainer.vue?vue&type=template&id=22652fc3&scoped=true&"
import script from "./comentariosContainer.vue?vue&type=script&lang=js&"
export * from "./comentariosContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22652fc3",
  null
  
)

export default component.exports